import { render, staticRenderFns } from "./VictoryPopup.vue?vue&type=template&id=25a57f82&scoped=true&"
import script from "./VictoryPopup.vue?vue&type=script&lang=ts&"
export * from "./VictoryPopup.vue?vue&type=script&lang=ts&"
import style0 from "./VictoryPopup.vue?vue&type=style&index=0&id=25a57f82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a57f82",
  null
  
)

export default component.exports